(function () {
  var items = document.querySelectorAll('.smelu-heritage-mini__item[data-reveal]');
  if (!items.length) return;

  items.forEach(function (item, i) {
    item.style.transitionDelay = (i * 0.1) + 's';
  });

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach(function (i) { i.classList.add('is-revealed'); });
    return;
  }

  if (!('IntersectionObserver' in window)) {
    items.forEach(function (i) { i.classList.add('is-revealed'); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });

  items.forEach(function (i) { io.observe(i); });
})();
